module.exports = __webpack_public_path__ + "static/img/left-num-row-2.27fca6ff.webp";